<div class="copyright">
    {{ "copyright" | translate:{'year': year} }} <a (click)="openPrivacyPolicy()">{{ "privacy.policy" | translate }}</a>
</div>